import Cookies from 'js-cookie'
import {setLoginState} from '@/utils/commonUtils'

const user = {
    state: {
        user: (localStorage.getItem('user') && localStorage.getItem('user') != "undefined") ? JSON.parse(localStorage.getItem('user')) : {},
        role: Cookies.get('role'),  //:0 普通用户， 1大使
    },

    mutations: {
        SET_USER: (state, user) => {
            state.user = user
            localStorage.setItem('user', JSON.stringify(user));
        },

        SET_ROLE: (state, role) => {
            state.role = role
            Cookies.set('role', role)
        }
    },

    actions: {
        //登录
        Login({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                window.axios.post("/user/code-login", userInfo).then(res => {
                    if(res.code === 324){
                        resolve(res)
                    }else {
                        const session = res.data.session
                        if (session) {
                            setLoginState(session)
                        }
                        if (res.data.userInfo) {
                            commit('SET_USER', res.data.userInfo)
                        }
                        if (res.data.role) {
                            commit('SET_ROLE', res.data.role)
                        }
                        resolve(res)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        LogOut({ commit }) {
            return new Promise((resolve, reject) => {
                commit('SET_USER', '')
                Cookies.remove("session")
                resolve()
            })
        },
        // 更新角色
        UpdateRole({ commit }, role) {
            if (role) {
                commit('SET_ROLE', role)
            }
        },
        //更新用户信息
        UpdateUserInfo({ commit }, userInfo) {
            commit('SET_USER', userInfo)
        }
    }
}

export default user
